import { render } from "./RequiredText.vue?vue&type=template&id=2a94d98b&scoped=true"
import script from "./RequiredText.vue?vue&type=script&lang=js"
export * from "./RequiredText.vue?vue&type=script&lang=js"

import "./RequiredText.vue?vue&type=style&index=0&id=2a94d98b&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a94d98b"]])

export default __exports__